"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.getPromConstantOptions=(e,t)=>e.map((({value:e,label:a})=>({value:e,label:t.formatMessage({id:e,defaultMessage:a})})));
